import { render, staticRenderFns } from "./paichejilu.vue?vue&type=template&id=3a1adcf1&scoped=true&"
import script from "./paichejilu.vue?vue&type=script&lang=js&"
export * from "./paichejilu.vue?vue&type=script&lang=js&"
import style0 from "./paichejilu.vue?vue&type=style&index=0&id=3a1adcf1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a1adcf1",
  null
  
)

export default component.exports